import { render, staticRenderFns } from "./Volumes.vue?vue&type=template&id=0a6b3344"
import script from "./Volumes.vue?vue&type=script&lang=js"
export * from "./Volumes.vue?vue&type=script&lang=js"
import style0 from "./Volumes.vue?vue&type=style&index=0&id=0a6b3344&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports